import { Box, CircularProgress, circularProgressClasses, CircularProgressProps, SxProps, Theme } from "@mui/material";
import * as React from 'react';

interface SpinnerProps extends CircularProgressProps {
  sx?: SxProps<Theme>;
}

export default function Spinner({ sx, ...props }: SpinnerProps) {
    return (
      <Box sx={{ position: 'relative', ...sx }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: '#FD3300',
            opacity: 0.3,
          }}
          size={40}
          thickness={4}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: '#FD3300',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          size={40}
          thickness={4}
          {...props}
        />
      </Box>
    );
  }